import React, { useEffect, useState } from 'react';
import { logout } from '../../utils/auth/session';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { NAVBAR_MENU_KEYS, NS } from '../../i18n/constants/keys';
import { translateRole } from '../../i18n/helpers/translateRole';
import ViewOption from './ViewOption';

export const MobileProfile = () => {
  const { t } = useTranslation(NS.navbarMenus);
  const history = useHistory();

  const [profilePic, setProfilePic] = useState<string>(() => {
    const raw = localStorage.getItem('profilePic') || '';
    return !raw || raw === 'null' || raw === 'undefined' || !raw.trim() ? '' : raw.trim();
  });
  const [firstName, setFirstName] = useState<string>(() => localStorage.getItem('firstname') || '');
  const [lastName, setLastName] = useState<string>(() => localStorage.getItem('lastname') || '');
  const [email, setEmail] = useState<string>(() => localStorage.getItem('email') || '');
  const role = localStorage.getItem('role') || 'Candidate';

  useEffect(() => {
    const handleProfileUpdate = (e?: Event) => {
      const customEvent = e as CustomEvent<{ profilePic?: string; firstName?: string; lastName?: string; email?: string }>;
      const newPic = customEvent?.detail?.profilePic ?? (localStorage.getItem('profilePic') || '');
      const cleanPic = !newPic || newPic === 'null' || newPic === 'undefined' || !newPic.trim() ? '' : newPic.trim();
      setProfilePic(cleanPic);

      const fn = customEvent?.detail?.firstName ?? (localStorage.getItem('firstname') || '');
      const ln = customEvent?.detail?.lastName ?? (localStorage.getItem('lastname') || '');
      const em = customEvent?.detail?.email ?? (localStorage.getItem('email') || '');
      setFirstName(fn);
      setLastName(ln);
      setEmail(em);
    };

    window.addEventListener('profilePicUpdated' as any, handleProfileUpdate);
    window.addEventListener('userProfileUpdated' as any, handleProfileUpdate);
    window.addEventListener('storage', handleProfileUpdate);

    return () => {
      window.removeEventListener('profilePicUpdated' as any, handleProfileUpdate);
      window.removeEventListener('userProfileUpdated' as any, handleProfileUpdate);
      window.removeEventListener('storage', handleProfileUpdate);
    };
  }, []);

  const user = {
    name: `${firstName} ${lastName}`.trim() || 'User',
    avatar: profilePic,
    initials: `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U',
    role,
    email,
  };

  const hasAvatar =
    Boolean(user.avatar) &&
    user.avatar !== 'null' &&
    user.avatar !== 'undefined' &&
    user.avatar.trim() !== '';

  const logOut = async () => {
    await logout();
    history.push('/login');
  };

  return (
    <div className='space-y-3'>
      <div className='rounded-xl border border-slate-200 bg-white p-3 shadow-sm'>
        <div className='flex items-center gap-3'>
          <div className='flex h-11 w-11 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-100 text-sm font-extrabold text-slate-700 ring-1 ring-slate-200'>
            { hasAvatar ? (
              <img
                  src={user.avatar}
                  alt={t(NAVBAR_MENU_KEYS.profile.userAvatarAlt)}
                  className='h-full w-full object-cover'
              />
            ) : (
              user.initials
            ) }
          </div>
          <div className='min-w-0 flex-1'>
            <p className='truncate text-sm font-extrabold text-slate-900'>
              { user.name }
            </p>
            { user.email && (
              <p className='truncate text-xs font-semibold text-slate-500'>
                { user.email }
              </p>
            ) }
            <span className='mt-1 inline-flex rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-bold uppercase text-emerald-700'>
              { translateRole(t, user.role) }
            </span>
          </div>
        </div>

        <div className='mt-3 grid grid-cols-2 gap-2'>
          <button
              className='rounded-lg border border-slate-200 px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50'
              onClick={() => history.push('/user-profile')}
          >
            {t(NAVBAR_MENU_KEYS.profile.items.profileSettings.title)}
          </button>
          <button
              className='rounded-lg border border-slate-200 px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-50'
              onClick={() => history.push('/change-password')}
          >
            {t(NAVBAR_MENU_KEYS.profile.items.changePassword.title)}
          </button>
        </div>
        <button
            className='mt-2 w-full rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-extrabold text-red-600 transition hover:bg-red-100'
            onClick={logOut}
        >
          {t(NAVBAR_MENU_KEYS.profile.logout)}
        </button>
      </div>

      <div className='rounded-xl border border-slate-200 bg-white p-3 shadow-sm'>
        <h3 className='mb-2 px-1 text-[11px] font-extrabold uppercase tracking-wide text-slate-400'>
          {t(NAVBAR_MENU_KEYS.profile.settings)}
        </h3>
        <ViewOption />
      </div>
    </div>
  );
};
